export const CUSTOMER_LOYALTY_SUMMARY_REQUESTING =
  'CUSTOMER_LOYALTY_SUMMARY_REQUESTING';
export const RESET_CUSTOMER_LOYALTY_SUMMARY_ISFETCHING =
  'RESET_CUSTOMER_LOYALTY_SUMMARY_ISFETCHING';

export const GET_CUSTOMER_LOYALTY_SUMMARY_REQUEST =
  'GET_CUSTOMER_LOYALTY_SUMMARY_REQUEST';
export const GET_CUSTOMER_LOYALTY_SUMMARY_SUCCESS =
  'GET_CUSTOMER_LOYALTY_SUMMARY_SUCCESS';
